import styled from '@emotion/styled';
import { theme } from '@vfit/shared/themes';

export const SuggestionItem = styled.li`
  list-style: none;
  padding: 8px 20px;
  color: ${theme.colors.text.secondary};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body1};
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &[data-highlighted='true'] {
    background-color: ${theme.colors.bg.disabled};
  }

  &:hover {
    cursor: pointer;
    background-color: ${theme.colors.bg.disabled};
  }
`;

